"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TransactionState;
(function (TransactionState) {
    /** accepted by a blockchain node and in mempool */
    TransactionState[TransactionState["Pending"] = 0] = "Pending";
    /** successfully written in a block, but cannot yet guarantee it won't be reverted */
    TransactionState[TransactionState["Succeeded"] = 1] = "Succeeded";
    /** executing the transaction failed */
    TransactionState[TransactionState["Failed"] = 2] = "Failed";
})(TransactionState = exports.TransactionState || (exports.TransactionState = {}));
function isBlockInfoPending(info) {
    return info.state === TransactionState.Pending;
}
exports.isBlockInfoPending = isBlockInfoPending;
function isBlockInfoSucceeded(info) {
    return info.state === TransactionState.Succeeded;
}
exports.isBlockInfoSucceeded = isBlockInfoSucceeded;
function isBlockInfoFailed(info) {
    return info.state === TransactionState.Failed;
}
exports.isBlockInfoFailed = isBlockInfoFailed;
// a type checker to use in the account-based queries
function isAddressQuery(query) {
    return query.address !== undefined;
}
exports.isAddressQuery = isAddressQuery;
function isPubkeyQuery(query) {
    return query.pubkey !== undefined;
}
exports.isPubkeyQuery = isPubkeyQuery;
//# sourceMappingURL=connection.js.map